import { render, staticRenderFns } from "./SelectLocale.vue?vue&type=template&id=757bb7fc&scoped=true&"
import script from "./SelectLocale.vue?vue&type=script&lang=ts&"
export * from "./SelectLocale.vue?vue&type=script&lang=ts&"
import style0 from "./SelectLocale.vue?vue&type=style&index=0&id=757bb7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757bb7fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
